import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';

// Datos de /api/conocimiento (guía 7.8, F4-01).

export type KbAudience = 'todos' | 'it';
export type KbStatus = 'borrador' | 'publicado' | 'archivado';

export interface ArticleSummary {
  id: string;
  number: number;
  code: string;
  title: string;
  summary: string;
  audience: KbAudience;
  status: KbStatus;
  category: string | null;
  app: string | null;
  tags: string[];
  viewCount: number;
  publishedAt: string | null;
  updatedAt: string;
}

export interface ArticleDetail extends ArticleSummary {
  body: string;
  categoryId: string | null;
  appEntryId: string | null;
  version: number;
  createdAt: string;
  createdBy: string | null;
  updatedBy: string | null;
  publishedBy: string | null;
  usedInTickets: number | null;
  can: { edit: boolean };
}

export interface ArticleVersion {
  version: number;
  title: string;
  status: KbStatus;
  editedBy: string | null;
  editedAt: string;
  current: boolean;
}

export interface KnowledgeForm {
  categories: Array<{ id: string; name: string; description: string | null }>;
  apps: Array<{ id: string; name: string; type: string; parentId: string | null }>;
  can: { publish: boolean; seeInternal: boolean };
}

export const useKnowledgeForm = () => useQuery({ queryKey: ['conocimiento', 'formulario'], queryFn: () => api<KnowledgeForm>('/api/conocimiento/formulario'), staleTime: 5 * 60_000 });
export const useArticle = (code: string) =>
  useQuery({ queryKey: ['conocimiento', 'articulo', code], queryFn: () => api<ArticleDetail>(`/api/conocimiento/${code}`), enabled: code !== '' });

export const formatDate = (iso: string) => new Date(iso).toLocaleDateString('es-PA', { day: 'numeric', month: 'long', year: 'numeric' });
